<template>
    <layout activeLabel="共享电工">
        <div class="btnGroup">
            <div
                    class="btnTab"
                    @click="statusChange(item)"
                    :class="item.value == query.status ? 'active' : ''"
                    v-for="(item, index) in needStatus"
                    :key="index"
            >
                {{ item.label }}
            </div>
        </div>
        <div style="padding: 15px">
            <el-form :model="query" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="工程名称" prop="title">
                    <el-input v-model="query.title" placeholder="请输入工程名称" clearable></el-input>
                </el-form-item>
                <!--<el-form-item label="状态" prop="status">-->
                <!--&lt;!&ndash;<el-input v-model="query.status" placeholder="请输入工程名称"></el-input>&ndash;&gt;-->
                <!--<el-select v-model="query.status" placeholder="请选择状态">-->
                <!--<el-option-->
                <!--v-for="item in needStatus"-->
                <!--:key="item.value"-->
                <!--:label="item.label"-->
                <!--:value="item.value">-->
                <!--</el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="queryTable">搜索</el-button>
                    <!--<el-button @click="resetForm">重置</el-button>-->
                </el-form-item>
            </el-form>
        </div>
        <div class="deviceTable">
            <el-table :data="tableData" default-expand-all :row-class-name="tableRowClassName" style="width: 100%"
                      stripe>
                <el-table-column type="index" label="序号" align="center" :index="count"></el-table-column>
                <el-table-column align="center" label="工程名称" prop="title" width="190"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column align="center" width="150" label="用工需求" prop="need"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column align="center" width="150" label="工程简介" prop="introduction"
                                 show-overflow-tooltip></el-table-column>
                <!--<el-table-column align="center" min-width="80" label="工程所需技能" prop="ability" ></el-table-column>-->
                <!--<el-table-column align="center" min-width="80" label="工程所需资质" prop="qualification" ></el-table-column>-->
                <el-table-column align="center" width="150" label="作业地点" prop="address"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column align="center" width="150" label="接单说明" prop="instruction"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column align="center" width="110" label="计划工程总额" prop="price"></el-table-column>
                <el-table-column align="center" width="100" label="人数限制" prop="number"></el-table-column>
                <el-table-column align="center" width="100" label="预计工期" prop="days"></el-table-column>
                <el-table-column align="center" label="当前状态" prop="desc" width="120">
                    <template scope="{row}">
                        <div class="time-line">
                            <div class="count">
                                {{ formatStatus(row.status) }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" prop="desc" width="200">
                    <template scope="{row}">
                        <div class="btns">
                            <span class="btn" @click="handleDetail(row)">查看</span>
                            <span class="btn" @click="release(row)" v-if="row.status == -1">发布</span>
                            <span class="btn" @click="delOrder(row)" v-if="row.status == -1">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex; justify-content: flex-end;margin-top: 20px;" v-if="total">
                <el-pagination
                        background
                        layout="prev, pager, next,total"
                        :total="total"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
    </layout>
</template>

<script>
import layout from "./index.vue";
import {getTobeReleased, delOrderShareElecticianOrder, deleteById} from "@/http/api/ordinary.js";
import api from "../../http/electrician/api.js";
import {addNeed} from "@/http/api/ordinary.js";
import {mapGetters} from 'vuex';

export default {
    name: "orderShare",
    components: {layout},
    data() {
        return {
            // activeTab: "全部",
            tableData: [],
            query: {
                pageSize: 15,
                pageNum: 1,
                status: '',
                title: ''
            },
            total: 0,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        count(index) {
            return (this.query.pageNum - 1) * this.query.pageSize + index + 1;
        },
        handleCurrentChange(val) {
            this.query.pageNum = val;
            this.getList();
        },
        delOrder(row) {
            this.$confirm("您确定要删除当前订单吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteById(row.id).then((res) => {
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                    this.getList();
                });
            });
        },
        handleDetail(row) {
            this.$router.push({
                path: "/orderDetail/detail",
                query: {
                    id: row.id,
                },
            });
        },
        statusChange(item) {
            this.query.pageNum = 1;
            this.query.status = item.value;
            this.getList();
        },
        getList() {
            getTobeReleased(this.query).then((res) => {
                this.tableData = res.rows
                this.total = res.total
            });
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex % 2 == 0) {
                return "warning-row";
            }
            return "";
        },
        // 格式化
        formatStatus(obj) {
            const data = this.needStatus.find(item => item.value === obj);
            if (data) {
                return data.label;
            }
            return "";
        },
        // 发布
        release(item) {
            addNeed({id: item.id || 0, status: 0}).then(res => {
                if (res.code === 200) {
                    this.$message.success("发布成功");
                    this.getList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //
        queryTable() {
            this.query.pageNum = 1;
            this.getList();
        },
        resetForm() {
            this.query.title = '';
            this.query.status = '';
            this.queryTable();
        }
    },
    computed: {
        ...mapGetters(['needStatus', 'orderStatus'])
    }
};
</script>
<style lang="less" scoped>
.btnGroup {
  border-bottom: 1px solid #f4f4f4;
  padding: 0 0.4rem 0.2rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;

  .btnTab {
    margin-top: 0.2rem;
    margin-right: 0.25rem;
    padding: 0.06rem 0.19rem;
    border-radius: 0.06rem;
    text-align: center;
    line-height: 0.2rem;
    font-size: 0.14rem;
    background: #ebebeb;
    color: #7d7d7d;
    cursor: pointer;

    &.active {
      color: #fff;
      background: #818181;
    }
  }
}

.deviceTable {
  padding: 0.1rem 0.4rem 0.4rem;
  box-sizing: border-box;
  min-height: calc(100vh - 2.5rem);
}

.deviceCard {
  padding-right: 1rem;
  padding-top: 0.48rem;
  box-sizing: border-box;
  display: flex;
}

.row-merge {
  padding: 0.18rem 0.33rem 0;
  display: flex;
  flex-wrap: wrap;

  &.order-row0 {
    background: #f2f2f2;
  }

  .order-item {
    width: 2.3rem;
    padding-bottom: 0.18rem;
    display: inline-flex;
    align-items: center;
  }

  .order-name {
    padding: 0 0.18rem;
    font-size: 0.14rem;
    color: #000;
  }
}

.logo {
  width: 0.38rem;
  min-width: 0.38rem;
  height: 0.38rem;
  border-radius: 0.07rem;
}

.nameBox {
  display: flex;
  align-items: center;

  .orderName {
    line-height: 0.38rem;
    padding-left: 0.14rem;
    color: #000;
    font-size: 0.14rem;
  }
}

.btns {
  .btn {
    padding: 0 0.16rem;
    color: blue;
    cursor: pointer;

    &.error {
      color: #f53232;
    }
  }
}

.time-line {
  .count {
    line-height: 0.2rem;
    padding-bottom: 0.09rem;
  }

  .status {
    color: #ff6b4a;
  }
}

/deep/ th .cell,
/deep/ tr .cell {
  color: #000;
  font-size: 0.14rem;
  font-weight: 500;
}

/deep/ .el-table__row {
  border-radius: 0.06rem;
}

/deep/ .warning-row {
  background: #f2f2f2;
  border-radius: 0.06rem;
}

/deep/ .el-table__expanded-cell {
  padding: 0;
}

/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell.is-leaf {
  border-bottom: unset;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

/deep/ .el-form-item {
  margin-bottom: 0px;
}
</style>
